module.exports = [
  {
    slug: 'packages',
    title: {de: 'Dashboard', en: 'Dashboard'},
    url: 'Page',
    index: 'packages-dashboard',
    icon: 'box'
  },
  {
    title: {de: 'Bestellungen', en: 'Orders'},
    url: 'Orders',
    subViews: [
      'Orders',
      'OrderDetails'
    ],
    icon: 'inbox'
  },
  {
    title: {de: 'Projekte', en: 'Projects'},
    url: 'Projects',
    index: 'tag:-Approval,status:0',
    subViews: [
      'ProjectDetails',
      'UploadStl'
    ],
    icon: 'cog',
    indicator: {
      api: 'project/',
      params: {
        status: 0,
        tag: '-Approval',
      }
    }
  },
  {
    slug: 'approvals',
    title: {en: 'Approvals', de: 'Freigaben'},
    url: 'Projects',
    index: 'tag:Approval,status:3',
    subViews: [
    ],
    icon: 'check',
    indicator: {
      api: 'project/',
      params: {
        status: 3,
        tag: 'Approval',
      }
    }
  },
  {
    title: 'Nachrichten',
    url: 'Messages',
    icon: 'comments'
  },
  {
    title: {de: 'Rechnung', en: 'Invoices'},
    url: 'Invoices',
    icon: 'receipt'
  }
];
